class BulkSizeOrder {
  constructor(el){
    this.el = el;
    this.sizeOptionIndex = parseInt(el.dataset.sizeOptionIndex,10);
    this.variants = JSON.parse(el.querySelector('.bulk-order__variant-data').textContent);
    this.variantMap = {}; this.variants.forEach(v=>{ this.variantMap[v.options.join('|')] = v; });
    this.qtyInputs = Array.from(el.querySelectorAll('.bulk-order__qty-input'));
    this.rows = Array.from(el.querySelectorAll('.bulk-order__row'));
    this.swatches = Array.from(el.querySelectorAll('.bulk-order__swatch'));
    this.totalCount = el.querySelector('.bulk-order__total-count');
    this.btn = el.querySelector('.bulk-order__btn');
    this.message = el.querySelector('.bulk-order__message');
    this.bagSelect = el.querySelector('.bulk-order__bag-select');
    this.nameToggle = el.querySelector('.bulk-order__name-toggle');
    this.nameFields = el.querySelector('.bulk-order__name-fields');
    this.nameInput = el.querySelector('.bulk-order__name-input');
    this.namePos = el.querySelector('.bulk-order__name-pos');
    this.nameHint = el.querySelector('.bulk-order__name-hint');
    this.bagNames = el.dataset.bagNames === '1';
    this.productHandle = ((location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0]||'').toLowerCase();
    this._applyColourBlocks();
    this._bind();
    const sel=this.el.querySelector('.bulk-order__swatch.is-selected')||this.swatches[0];
    if(sel) this._setCrest(sel.dataset.value);
  }
  _applyColourBlocks(){
    const M=BulkSizeOrder.COLOUR_MAP||{};
    this.swatches.forEach(sw=>{
      if(!sw.hasAttribute('data-noimg')) return;
      const n=(sw.dataset.value||'').toLowerCase().trim();
      let hex=M[n];
      if(!hex){ for(const k in M){ if(n.indexOf(k)!==-1){ hex=M[k]; break; } } }
      if(hex){ sw.style.background=hex; sw.textContent=''; sw.removeAttribute('data-noimg'); if(hex==='#ffffff'){ sw.style.boxShadow='inset 0 0 0 1px rgba(15,15,15,0.2)'; } }
    });
  }
  _bind(){
    this.qtyInputs.forEach(i=>{ i.addEventListener('input',()=>{this._clamp(i);this._total();this._hideMsg();}); i.addEventListener('change',()=>{this._clamp(i);this._total();}); });
    this.swatches.forEach(s=>s.addEventListener('click',()=>this._selectSwatch(s)));
    if(this.nameToggle){ this.nameToggle.addEventListener('change',()=>{ if(this.nameFields){ this.nameFields.hidden=!this.nameToggle.checked; } if(this.nameToggle.checked&&this.nameInput){ this.nameInput.focus(); } this._updateNameOverlay(); }); }
    if(this.nameInput){ this.nameInput.addEventListener('input',()=>this._updateNameOverlay()); }
    if(this.namePos){ this.namePos.addEventListener('change',()=>{ this._updateHint(); this._updateNameOverlay(); }); }
    if(this.bagNames){
      this.el.querySelectorAll('.bulk-order__bagnames').forEach(n=>{
        const sync=()=>{
          const row=n.closest('.bulk-order__row'); const q=row&&row.querySelector('.bulk-order__qty-input'); if(!q) return;
          const c=BulkSizeOrder.splitNames(n.value).length;
          if(c>(parseInt(q.value,10)||0)){ q.value=c; this._clamp(q); this._total(); }
          this._hideMsg();
        };
        n.addEventListener('input',sync); n.addEventListener('change',sync);
      });
    }
    this.btn.addEventListener('click',()=>this._add());
  }
  _clamp(i){ let v=parseInt(i.value,10); if(isNaN(v)||v<0)v=0; i.value=v; i.classList.toggle('is-active',v>0); }
  _total(){ const t=this.qtyInputs.reduce((s,i)=>s+(parseInt(i.value,10)||0),0); this.totalCount.textContent=t; this.btn.disabled=t===0; }
  _updateHint(){
    if(!this.nameHint) return;
    const pos=this.namePos?this.namePos.value:'';
    if(pos==='Upper back'){ this.nameHint.textContent='Printed across the upper back, not shown on this front view.'; }
    else if(pos==='Sleeve'){ this.nameHint.textContent='Printed on the sleeve, preview is approximate.'; }
    else { this.nameHint.textContent='Preview shown on the garment, exact position finalised at production.'; }
  }
  _updateNameOverlay(){
    const gallery=document.querySelector('media-gallery'); if(!gallery) return;
    gallery.querySelectorAll('.cccc-name-ov').forEach(o=>o.remove());
    if(!(this.nameToggle&&this.nameToggle.checked)) return;
    const txt=(this.nameInput&&this.nameInput.value.trim())||''; if(!txt) return;
    const pos=this.namePos?this.namePos.value:'Right chest';
    const C={'Right chest':{top:'36%',left:'31%'},'Left chest':{top:'36%',left:'61%'},'Centre chest':{top:'33%',left:'50%',c:true},'Sleeve':{top:'31%',left:'12%'}};
    if(!C[pos]) return;
    const item=gallery.querySelector('.product__media-item.is-active')||gallery.querySelector('.product__media-item'); if(!item) return;
    item.style.position='relative';
    const ov=document.createElement('div'); ov.className='cccc-name-ov';
    const co=C[pos]; const w=(item.getBoundingClientRect().width)||320;
    const lightG=gallery.classList.contains('cccc-light');
    ov.textContent=txt.toUpperCase(); ov.style.top=co.top; ov.style.left=co.left; ov.style.transform=co.c?'translateX(-50%)':'none'; ov.style.fontSize=(w*0.03)+'px';
    ov.style.color=lightG?'#0F0F0F':'#ffffff';
    ov.style.textShadow=lightG?'0 1px 2px rgba(255,255,255,0.6)':'0 1px 3px rgba(0,0,0,0.55)';
    item.appendChild(ov);
  }
  _selectSwatch(sw){
    const idx=sw.dataset.optionIndex;
    this.el.querySelectorAll('.bulk-order__swatch[data-option-index="'+idx+'"]').forEach(o=>o.classList.remove('is-selected'));
    sw.classList.add('is-selected');
    const opt=sw.closest('.bulk-order__option'); const cur=opt&&opt.querySelector('.bulk-order__option-current'); if(cur) cur.textContent=sw.dataset.value;
    this._reresolve();
    this._setImage(sw.dataset.mediaId);
    this._setCrest(sw.dataset.value);
    setTimeout(()=>this._updateNameOverlay(),200);
  }
  _setCrest(name){
    if(!name) return;
    const gallery=document.querySelector('media-gallery'); if(!gallery) return;
    const n=name.toLowerCase();
    const light=/(white|arctic|natural|\bash\b|sky|light blue|powder|lavender|sunflower|\bcream\b|ecru|\bmint\b|\bsilver\b|heather grey|heather gray|\bice\b|\bsnow\b|pale|soft)/.test(n) && !/(dark|charcoal|navy|black|deep|bottle|forest|royal)/.test(n);
    gallery.classList.toggle('cccc-light', light);
    const T=BulkSizeOrder.CREST_POS||{};
    const p=(T[this.productHandle]&&T[this.productHandle][n]) || (T['*']&&T['*'][n]) || {};
    gallery.style.setProperty('--cccc-top', p.top||'');
    gallery.style.setProperty('--cccc-left', p.left||'');
    gallery.style.setProperty('--cccc-w', p.w||'');
  }
  _reresolve(){
    const nz={};
    this.el.querySelectorAll('.bulk-order__swatch.is-selected').forEach(s=>{ nz[parseInt(s.dataset.optionIndex,10)]=s.dataset.value; });
    this.rows.forEach(row=>{
      const opts=new Array(this.variants[0].options.length);
      opts[this.sizeOptionIndex]=row.dataset.size;
      Object.entries(nz).forEach(([i,v])=>opts[parseInt(i,10)]=v);
      const variant=this.variantMap[opts.join('|')]; if(!variant) return;
      const input=row.querySelector('.bulk-order__qty-input');
      row.dataset.variantId=variant.id; input.dataset.variantId=variant.id;
      input.disabled=!variant.available; if(!variant.available) input.value=0;
      row.classList.toggle('bulk-order__row--unavailable',!variant.available);
      const badge=row.querySelector('.bulk-order__badge');
      if(badge){ badge.className=variant.available?'bulk-order__badge bulk-order__badge--available':'bulk-order__badge bulk-order__badge--unavailable'; badge.textContent=variant.available?'In Stock':'Out of Stock'; }
    });
    this._total();
  }
  _setImage(mediaId){
    if(!mediaId) return;
    const gallery=document.querySelector('media-gallery');
    if(!gallery) return;
    const slide=Array.from(gallery.querySelectorAll('[data-media-id]')).find(el=>el.dataset.mediaId && el.dataset.mediaId.endsWith('-'+mediaId));
    if(slide && typeof gallery.setActiveMedia==='function'){ try{ gallery.setActiveMedia(slide.dataset.mediaId,true); return; }catch(e){} }
    const thumb=Array.from(gallery.querySelectorAll('[data-target]')).find(el=>el.dataset.target && el.dataset.target.endsWith('-'+mediaId));
    if(thumb){ const b=thumb.querySelector('button'); if(b){ b.click(); return; } }
    if(slide && slide.scrollIntoView){ slide.scrollIntoView({behavior:'smooth',block:'center'}); }
  }
  _buildItems(){
    const items=[];
    this.qtyInputs.forEach(i=>{
      const q=parseInt(i.value,10)||0; if(q<=0) return;
      const id=parseInt(i.dataset.variantId,10);
      const row=i.closest('.bulk-order__row'); const n=this.bagNames&&row?row.querySelector('.bulk-order__bagnames'):null;
      const names=n?BulkSizeOrder.splitNames(n.value).slice(0,q):[];
      // One cart line per named person, so the packing slip shows whose bag each item goes in
      names.forEach(nm=>items.push({id,quantity:1,properties:{'Bag for':nm}}));
      if(q-names.length>0) items.push({id,quantity:q-names.length});
    });
    return items;
  }
  static splitNames(v){ return String(v||'').split(/[,\n;]+/).map(x=>x.trim()).filter(Boolean); }
  async _add(){
    const items=this._buildItems(); if(!items.length) return;
    const garmentCount=items.reduce((s,i)=>s+i.quantity,0);
    let nameTxt='';
    if(this.nameToggle && this.nameToggle.checked){
      nameTxt=(this.nameInput && this.nameInput.value.trim())||'';
      if(!nameTxt){ this._msg('Please enter the name or number to print, or untick personalisation.','error'); if(this.nameInput) this.nameInput.focus(); return; }
    }
    if(this.bagSelect && this.bagSelect.value){
      const lbl=this.bagSelect.options[this.bagSelect.selectedIndex].text.split(', ')[0].trim();
      items.push({id:parseInt(this.bagSelect.value,10),quantity:garmentCount,properties:{'Add-on':'Bagging, '+lbl}});
    }
    if(nameTxt){ items.push({id:parseInt(this.nameToggle.dataset.nameVariant,10),quantity:garmentCount,properties:{'Personalisation':nameTxt,'Position':(this.namePos?this.namePos.value:'')}}); }
    this._setLoading(true); this._hideMsg();
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const d=await r.json();
      if(!r.ok){ this._msg(d.description||d.message||'Could not add items to cart.','error'); return; }
      this.qtyInputs.forEach(i=>{i.value=0;i.classList.remove('is-active');}); this.el.querySelectorAll('.bulk-order__bagnames').forEach(n=>{n.value='';}); this._total();
      if(this.bagSelect) this.bagSelect.value='';
      if(this.nameToggle){ this.nameToggle.checked=false; if(this.nameFields) this.nameFields.hidden=true; if(this.nameInput) this.nameInput.value=''; }
      this._updateNameOverlay();
      this._msg('✓ '+garmentCount+' item'+(garmentCount!==1?'s':'')+' added to your cart.','success');
      this._refreshCart();
    }catch(e){ this._msg('Something went wrong. Please try again.','error'); }
    finally{ this._setLoading(false); }
  }
  _setLoading(l){ this.btn.classList.toggle('is-loading',l); this.btn.disabled=l; }
  _msg(t,type){ this.message.textContent=t; this.message.className='bulk-order__message bulk-order__message--'+type; this.message.hidden=false; }
  _hideMsg(){ this.message.hidden=true; this.message.textContent=''; }
  async _refreshCart(){ try{ const res=await fetch('/cart.js',{headers:{Accept:'application/json'}}); const c=await res.json(); document.querySelectorAll('.cart-count-bubble').forEach(b=>{ b.hidden=c.item_count===0; const v=b.querySelector('[aria-hidden="true"]'); if(v) v.textContent=c.item_count; }); if(typeof window.publish==='function') window.publish('cart:refresh',{source:'bulk-size-order'}); }catch(e){} }
  static init(){ document.querySelectorAll('.bulk-order').forEach(el=>{ if(!el.dataset.bsoInit){el.dataset.bsoInit='1'; new BulkSizeOrder(el);} }); }
}
BulkSizeOrder.COLOUR_MAP = {'black':'#1a1a1a','jet black':'#0d0d0d','deep black':'#0d0d0d','white':'#ffffff','arctic white':'#ffffff','natural':'#efe7d6','ecru':'#efe7d6','cream':'#f3ead3','sand':'#d8c9a3','biscuit':'#d9c4a0','navy':'#20294a','deep navy':'#1b2440','french navy':'#1b2440','oxford navy':'#1b2440','red':'#c0202a','classic red':'#c0202a','bright red':'#d12631','burgundy':'#6d1f2e','maroon':'#5e1a2b','royal':'#1f4fb0','bright royal':'#1f4fb0','royal blue':'#1f4fb0','sapphire':'#1e63a8','sapphire blue':'#1e63a8','cobalt':'#2b50a0','azure':'#3a78c2','sky':'#7fb9e6','sky blue':'#7fb9e6','light blue':'#a9cde8','dusty blue':'#90a8c0','airforce blue':'#5a7a99','turquoise':'#2bb6c4','teal':'#1f8a8a','bottle green':'#0f3b2e','bottle':'#0f3b2e','forest':'#16432c','forest green':'#16432c','kelly':'#1f8f48','kelly green':'#1f8f48','emerald':'#1f9d6b','green':'#1f8f48','lime':'#9cc63b','lime green':'#9cc63b','olive':'#6b6a2f','khaki':'#7c734a','sage':'#9bae8e','mint':'#a9e0c6','charcoal':'#3a3a3a','dark grey':'#4a4a4a','dark heather grey':'#5a5a5a','graphite':'#4a4a4a','graphite grey':'#4a4a4a','heather grey':'#9b9b9b','heather gray':'#9b9b9b','grey':'#9b9b9b','gray':'#9b9b9b','sport grey':'#a8a8a8','light grey':'#cfcfcf','light oxford':'#cfcfcf','zinc':'#bdbdbd','silver':'#c8c8c8','ash':'#d7d7d2','heather purple':'#6a4f86','purple':'#5b3a8a','heather burgundy':'#7a3346','plum':'#5e2a4d','fuchsia':'#c43d8a','pink':'#e58fb0','classic pink':'#e58fb0','light pink':'#f1c4d4','powder rose':'#e3b7c2','rose':'#d98aa0','coral':'#f08a6d','yellow':'#f4d03f','gold':'#e3b341','sunflower':'#f4c430','orange':'#e8732a','flame':'#e0533a','chocolate':'#4b3424','brown':'#5a3d2b','caramel':'#b07a45'};
BulkSizeOrder.CREST_POS = {
  '*': { 'black': { top: '20.5%' } },
  'coventry-classic-car-club-pro-rtx-pique-polo-shirt-1': { 'turquoise': { top: '29.5%' } }
};
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',BulkSizeOrder.init); } else { BulkSizeOrder.init(); }
